
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { Line2 } from 'three/examples/jsm/lines/Line2.js'
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js'
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js'
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';

let animation, camera, controls, gridhelper, height, redisplay, renderer, rotate, runcheck, scene, width
let colors, colorType, colorsNow, lineWidthPrint, lineWidthTravel, pathPoints, plotType, points, positions
let biggestDim = 0, dims, xvals, yvals, zvals
let geometryLine, geometryTube, materialTube, pathCount, pathTube
let printing = [], mesh = [], line = []
let annotations, nodeRadius = 1, labelRenderer, nodeMaterial, nodeMesh = [], nodeGeometry, nodeDiv = [], nodeLabel, nodeCount = 0, showAnnotations

export const initialiseScene = () => {
    scene = new THREE.Scene()
    renderer = new THREE.WebGLRenderer({ antialias: true })
    scene.clear()

    const target = document.getElementById('target'), border = target.offsetWidth - target.clientWidth
    width = target.getBoundingClientRect().width - border
    height = target.getBoundingClientRect().height - border
    renderer.setSize(width, height)
    target.appendChild(renderer.domElement)
    camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 10000)

    // in the future, the grid can be set to match the size of the print bed for a chosen printer
    const gridSize = 4000, gridSpacing = 200
    gridhelper = new THREE.GridHelper(gridSize, gridSpacing, 0x444444, 0x444444)
    // gridhelper.position.x = gridSize / 2 // move grid so corner is at 0,0
    // gridhelper.position.z = -gridSize / 2 // move grid so corner is at 0,0
    scene.add(gridhelper)
    renderer.setClearColor('#000000')
    const color = 0x000000, near = 400, far = 800;
    scene.fog = new THREE.Fog(color, near, far);

    // add annotations
    labelRenderer = new CSS2DRenderer();
    labelRenderer.setSize(width, height);
    labelRenderer.domElement.style.position = 'absolute';
    labelRenderer.domElement.style.top = '0px';
    document.getElementById('target').appendChild(labelRenderer.domElement);

    controls = new OrbitControls(camera, labelRenderer.domElement)
    controls.enablePan = true
}

var addAnnotations = () => {

    nodeMaterial = new THREE.MeshNormalMaterial();
    nodeGeometry = new THREE.SphereBufferGeometry(nodeRadius, 16, 16);

    for (var node = 0; node < nodeCount; node++) {
        nodeMesh[node] = new THREE.Mesh(nodeGeometry, nodeMaterial);
        scene.add(nodeMesh[node]);

        nodeDiv[node] = document.createElement('div');
        nodeDiv[node].className = 'annotationClass';
        nodeDiv[node].style.marginTop = '-1em';
        nodeLabel[node] = new CSS2DObject(nodeDiv[node]);
        nodeLabel[node].position.set(0, nodeRadius, 0);
        nodeMesh[node].add(nodeLabel[node]);

        nodeMesh[node].position.set(annotations[node].x, annotations[node].z, -annotations[node].y);
        nodeDiv[node].textContent = annotations[node].label;
    }
}

var generateColors = () => {
    colors = {}
    colors["zGradient"] = [];
    colors["RandomBlue"] = [];
    colors["PrintSequence"] = [];
    colors["PrintSequenceFluctuating"] = [];
    let totalPoints = 0
    for (var path = 0; path < pathCount; path++) {
        pathPoints = xvals[path].length
        for (var i = 0; i < pathPoints; i++) {
            totalPoints += 1
        }
    }
    let fluctuations = 5
    let pointCount = 0
    for (var path = 0; path < pathCount; path++) {
        colors['zGradient'].push([])
        colors['RandomBlue'].push([])
        colors['PrintSequence'].push([])
        colors['PrintSequenceFluctuating'].push([])
        pathPoints = xvals[path].length
        if (printing[path] == true) {
            for (var i = 0; i < pathPoints; i++) {
                pointCount += 1
                // colors['zGradient'][path].push(1, 1, 1)
                colors['zGradient'][path].push(0, (zvals[path][i] - dims.minz + 0.00000001) / (dims.maxz - dims.minz + 0.00000002), 1)
                colors['RandomBlue'][path].push(0, Math.random(), 1)
                colors['PrintSequence'][path].push(0.8 * Math.max(1 - (2 * pointCount / totalPoints), 0), Math.max((2 * pointCount / totalPoints) - 1, 0), 1)
                colors['PrintSequenceFluctuating'][path].push(0.25 + 0.25 * Math.sin((((pointCount % (totalPoints / fluctuations)) + 0.00001) / (totalPoints / fluctuations)) * (2 * Math.PI)),
                    0.5 - 0.5 * Math.cos((((pointCount % (totalPoints / fluctuations)) + 0.00001) / (totalPoints / fluctuations)) * (2 * Math.PI)),
                    1)
            }
        } else {
            for (var i = 0; i < pathPoints; i++) {
                pointCount += 1
                colors['zGradient'][path].push(0.75, 0.5, 0.5)
                colors['RandomBlue'][path].push(0.75, 0.5, 0.5)
                colors['PrintSequence'][path].push(0.75, 0.5, 0.5)
                colors['PrintSequenceFluctuating'][path].push(0.75, 0.5, 0.5)
            }
        }
    }
    // Math.max(Math.abs(dims.maxx - dims.minx), Math.abs(dims.maxy - dims.miny), Math.abs(dims.maxz - dims.minz))
    // colorsNow = colors[colorType]
}

export const controlVisualisation = (params) => {
    let redisplay = false
    if (lineWidthPrint != params.lineWidth) {
        lineWidthPrint = params.lineWidth
        lineWidthTravel = lineWidthPrint / 4
        redisplay = true
    }
    if (showAnnotations != params.annotations) {
        showAnnotations = params.annotations
        redisplay = true
    }
    if (params.plotType != plotType) {
        plotType = params.plotType
        redisplay = true
    }
    if (plotType == 'line') {
        if (params.colorType != colorType) {
            colorType = params.colorType
            colorsNow = colors[colorType]
            redisplay = true
        }
    }
    if (redisplay) {
        displayPath()
    }
}

export const positionCamera = () => {
    controls.target.set(dims.midx, dims.midz, -dims.midy)
    camera.position.x = dims.midx - biggestDim / 5
    camera.position.z = -dims.midy + biggestDim
    camera.position.y = dims.midz + biggestDim
    controls.update()
}

export const initialiseModel = (params, pythonData) => {
    showAnnotations = true
    colorType = null
    plotType = null
    runcheck = false // this is used to allow the camera to only be posisitioned once, otherwise resizing object has minimal visual effect
}

export const concludeModel = () => {
    cancelAnimationFrame(animation) // in case a previous model was running
}

export const regenerateModel = (params, pythonData, visParams) => {
    // console.log('pythonData', pythonData)
    clearScene() // clear scene before resetting the parameters for mesh and line
    pathCount = pythonData.xvals.length
    xvals = pythonData.xvals
    yvals = pythonData.yvals
    zvals = pythonData.zvals
    // console.log('pythonData in visualize.js: ', pythonData)
    printing = pythonData.printing
    // colors = pythonData.colors
    dims = pythonData.dims
    generateColors()
    annotations = pythonData.annotations
    // since the y and z axis are swapped, the 'right hand rule' means y must be flipped
    // in the future, consider doing all swaps and y and z here, so the threejs code is simpler
    for (var i = 0; i < yvals.length; i++) {
        for (var j = 0; j < yvals[i].length; j++) {
            yvals[i][j] = -yvals[i][j]
        }
    }



    mesh = [0 * pathCount] // these are needed because if I assigned THREE objects with array.push, there were problems, so I need to assign them to array[i]
    line = [0 * pathCount]
    geometryTube = [0 * pathCount]
    geometryLine = [0 * pathCount]
    pathTube = [0 * pathCount]
    colorsNow = colors[colorType] // this is needed in case the size of the colors array is changed when the model updates

    nodeCount = annotations.length
    nodeMesh = [0 * nodeCount] // these are needed because if I assigned THREE objects with array.push, there were problems, so I need to assign them to array[i]
    nodeDiv = [0 * nodeCount]
    nodeLabel = [0 * nodeCount]

    biggestDim = Math.max(Math.abs(dims.maxx - dims.minx), Math.abs(dims.maxy - dims.miny), Math.abs(dims.maxz - dims.minz))
    nodeRadius = Math.max(0.25, biggestDim / 150)

    generateLinePaths()
    // generateTubePaths() // TubeGeometry has some limitations which make it only useful for some geometry, and it's slow to generate paths for. Disabled for now
    controlVisualisation(visParams)
    displayPath()
    if (!runcheck) {
        positionCamera()
        runcheck = true
        render()
    }
    controls.update()
}

const displayPath = () => {
    if (plotType == 'tube') plotTube()
    else plotLine()
}

const clearScene = () => {
    //remove models
    for (var i = 0; i < pathCount; i++) {
        scene.remove(mesh[i])
        scene.remove(line[i])
    }
    //remove annotations
    for (var i = 0; i < nodeCount; i++) {
        scene.remove(nodeMesh[i])
        // nodeDiv[i].remove() // this causes an error the very first time the scene is cleared (when it may or may not have content)
    }
    const annotationClasses = document.querySelectorAll('.annotationClass');
    annotationClasses.forEach(annotationClass => {
        annotationClass.remove();
    });
}
const plotTube = () => {
    clearScene()
    alert('TubeGeometry is not supported at the moment');
    // if (showAnnotations) {addAnnotations()}
    // for (var path = 0; path < pathCount; path ++) {
    //     if (printing[path] == true) {
    //         mesh[path] = new THREE.Mesh(geometryTube[path], materialTube)
    //         scene.add(mesh[path])
    //     }
    // }
}

const plotLine = () => {
    clearScene()
    if (showAnnotations) { addAnnotations() }
    let matLinePrint, matLineTravel, matLine
    matLinePrint = new LineMaterial({ linewidth: lineWidthPrint, vertexColors: true })
    matLineTravel = new LineMaterial({ linewidth: lineWidthTravel, vertexColors: true })
    for (var path = 0; path < pathCount; path++) {
        geometryLine[path] = new LineGeometry()
        geometryLine[path].setPositions(positions[path])
        geometryLine[path].setColors(colorsNow[path])

        if (printing[path]) matLine = matLinePrint
        else matLine = matLineTravel
        line[path] = new Line2(geometryLine[path], matLine)
        line[path].computeLineDistances()
        line[path].scale.set(1, 1, 1)
        matLine.resolution.set(width, height)
        scene.add(line[path])
    }
}

const generateTubePaths = () => {
    let tubeSegs
    points = []
    for (var path = 0; path < pathCount; path++) {
        points.push([])
        points[path] = []
        pathPoints = xvals[path].length
        for (var i = 0; i < pathPoints; i++) {
            points[path].push(new THREE.Vector3(xvals[path][i], zvals[path][i], yvals[path][i])) // notice y and z swap
        }
        pathTube[path] = new THREE.CatmullRomCurve3(points[path], false, 'catmullrom', 0)
        if (pathPoints < 2000) tubeSegs = 10000
        else tubeSegs = pathPoints - 1
        geometryTube[path] = new THREE.TubeGeometry(pathTube[path], tubeSegs, 0.5, 16, false)
    }
    materialTube = new THREE.MeshNormalMaterial()
}

const generateLinePaths = () => {
    positions = [];
    for (var path = 0; path < pathCount; path++) {
        positions.push([])
        positions[path] = []
        pathPoints = xvals[path].length
        for (var i = 0; i < pathPoints; i++) {
            positions[path].push(xvals[path][i], zvals[path][i], yvals[path][i]) // notice y and z swap
        }
    }
}

const render = () => {
    animation = requestAnimationFrame(render)
    renderer.render(scene, camera)
    labelRenderer.render(scene, camera);
}
